var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "mb-4",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.addCard.apply(null, arguments)
        },
      },
    },
    [
      _c("PaymentCardForm", {
        staticClass: "mb-2",
        on: { change: _vm.onPaymentCardDataChange },
      }),
      _vm.isErrorShown
        ? _c("FormError", { attrs: { errorMessage: _vm.error } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pt-3" },
        [
          _vm._t(
            "default",
            function () {
              return [
                _c("UIButton", {
                  attrs: {
                    type: "submit",
                    fullWidth: "",
                    buttonText: _vm.buttonText,
                    disabled: !_vm.cardDataValid,
                    processing: _vm.isProcessing,
                  },
                }),
              ]
            },
            { addCard: _vm.addCard, disabled: !_vm.cardDataValid }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }